import { XML_ScaleAndShiftX } from "./XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "./XML_ScaleAndShiftY";

export function XML_DrawBoxGroupHighlightPPT(
  xOffset,
  yOffset,
  poly,
  fillStyle,
  drawElement,
  layer
) {
  var numPoints = poly.fPoints.length;
  if (numPoints > 0) {
    var point = poly.fPoints[numPoints - 1];
    var xStart = point.x + xOffset;
    var yStart = point.y + yOffset;
    var s = drawElement.GetStream();

    var points = [];
    var theFillStyle = fillStyle ? fillStyle : "#ffffff";
    points.push(theFillStyle);
    for (var i = 0; i < numPoints; i++) {
      var pointX = poly.fPoints[i].x + xOffset;
      var pointY = poly.fPoints[i].y + yOffset;

      var x1 = XML_ScaleAndShiftX(pointX, drawElement, layer);
      var y1 = XML_ScaleAndShiftY(pointY, drawElement, layer);
      y1 = drawElement.ConvertY(y1);
      points.push(x1);
      points.push(y1);
    }
    drawElement.OutputElementList("hlt", points, s);
  }
}
